export default __webpack_public_path__ + "static/media/bqb-logo.5fad5446.png";